import { OUT_OF_SCOPE_PREFIX } from "../../lib/reviewLines";

// 0051 S1b: why the card asks. Every question may carry the one Why line; a
// scope question also shows the line in the out-of-scope list it is about and
// the decisions it lists under one heading - those that cross the line, or on a
// collision-born question those that need the obligation the line rules out -
// so the line and the decisions are one read. Every text wraps rather than
// widening the card on a phone.
export function WhyLine({
  line,
  outOfScopeEntry,
  heading,
  crossing,
}: {
  line: string;
  outOfScopeEntry: string;
  heading: string;
  crossing: string[];
}) {
  if (line === "" && outOfScopeEntry === "" && crossing.length === 0) return null;
  return (
    <div className="mt-3 min-w-0 space-y-2">
      {line !== "" && (
        <p data-testid="why-line" className="break-words text-[13px] text-ink-400 leading-relaxed">
          {line}
        </p>
      )}
      {outOfScopeEntry !== "" && (
        <p data-testid="out-of-scope-line" className="break-words text-[13px] text-ink-400 leading-relaxed">
          <span className="font-mono text-[10px] uppercase tracking-widest text-ink-500">{OUT_OF_SCOPE_PREFIX}</span>
          {outOfScopeEntry}
        </p>
      )}
      {crossing.length > 0 && (
        <div data-testid="crossing-decisions">
          <p className="font-mono text-[10px] uppercase tracking-widest text-ink-500">{heading}</p>
          <ul className="mt-1 space-y-1 break-words text-[13px] text-ink-300">
            {crossing.map((title, i) => (
              <li key={`${i}-${title}`}>{title}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
